var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfinishedTransactionsElementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F3F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 17.3107L17.9996 21.1996M17.9996 21.1996L13.9996 17.3107M17.9996 21.1996L17.9996 11.5996M11.5996 24.3996H24.3996",
    stroke: "#4D5975",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfinishedTransactionsElementIcon);
export default __webpack_public_path__ + "static/media/UnfinishedTransactionsElementIcon.49b6469413f79e30479390bf36b66571.svg";
export { ForwardRef as ReactComponent };